import { render, staticRenderFns } from "./PageUnauthorized.vue?vue&type=template&id=36b0792d&"
import script from "./PageUnauthorized.vue?vue&type=script&lang=ts&"
export * from "./PageUnauthorized.vue?vue&type=script&lang=ts&"
import style0 from "./PageUnauthorized.vue?vue&type=style&index=0&id=36b0792d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports